import {IJobs} from '../../../api/types/aiReview.type';
import {generateRandomNumber} from '../../../utils/utils';

export const MockJobs: IJobs[] = [
  //keeping only 2 mock jobs where status is complete

  // {
  //   jobId: 31,
  //   jobName: 'Demo Priv Log Description JKL',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: null,
  //   createdBy: 'Katz, Shane',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: null,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'Draft',
  //   jobGroupName: 'Artificial 123456789 Artificial test',
  //   jobGroupId: 1,
  // },
  {
    jobId: 30,
    jobName: 'Demo Review Job Group GHI',
    jobType: 'Relevancy',
    createdDate: '2025/02/06 14:26:36',
    executionDate: '2025/02/06 14:26:36',
    createdBy: 'Boudia, David',
    source: 'Saved Search: 418349',
    totalDocCount: 10000,
    completedDocCount: 5000,
    excludedErrorDocCount: 5000,
    status: 'Complete',
    jobGroupName: 'Group 2',
    jobGroupId: 2,
  },
  // {
  //   jobId: 29,
  //   jobName: 'Demo Job Group 123',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: null,
  //   createdBy: 'Boisclair, Gerard',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 0,
  //   excludedErrorDocCount: 10000,
  //   status: 'Failed',
  //   jobGroupName: null,
  //   jobGroupId: null,
  // },
  // {
  //   jobId: 28,
  //   jobName: 'TestingKara',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Coles, group',
  //   source: 'Saved Search: 418',
  //   totalDocCount: 10000,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'In Progress',
  //   jobGroupName: 'Group 3',
  //   jobGroupId: 3,
  // },
  // {
  //   jobId: 27,
  //   jobName: 'ztest1',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Boisclair, null',
  //   source: 'Saved Search: 419',
  //   totalDocCount: null,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'In Progress',
  //   jobGroupName: null,
  //   jobGroupId: null,
  // },
  {
    jobId: 26,
    jobName: 'Demo Job Group 123',
    jobType: 'Issue Coding',
    createdDate: '2025/02/06 14:26:36',
    executionDate: '2025/02/06 14:26:36',
    createdBy: 'Boudia, David',
    source: 'Saved Search: 418349',
    totalDocCount: 10000,
    completedDocCount: 5000,
    excludedErrorDocCount: 5000,
    status: 'Complete',
    jobGroupName: 'Group 2',
    jobGroupId: 2,
  },
  // {
  //   jobId: 25,
  //   jobName: 'Demo Priv Log Description JKL',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: null,
  //   createdBy: 'Katz, Shane',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: null,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'Draft',
  //   jobGroupName: 'Group 3',
  //   jobGroupId: 3,
  // },
  // {
  //   jobId: 24,
  //   jobName: 'Demo Review Job Group GHI',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Boudia, David',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 5000,
  //   excludedErrorDocCount: 5000,
  //   status: 'Complete',
  //   jobGroupName: null,
  //   jobGroupId: null,
  // },
  // {
  //   jobId: 23,
  //   jobName: 'Demo Job Group 123',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: null,
  //   createdBy: 'Boisclair, Gerard',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 0,
  //   excludedErrorDocCount: 10000,
  //   status: 'Failed',
  //   jobGroupName: 'Group 1',
  //   jobGroupId: 1,
  // },
  // {
  //   jobId: 22,
  //   jobName: 'TestingKara',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Coles, Chad',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'In Progress',
  //   jobGroupName: 'Group 3',
  //   jobGroupId: 3,
  // },
  // {
  //   jobId: 21,
  //   jobName: 'ztest1',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Boisclair, Gerard',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'In Progress',
  //   jobGroupName: 'Group 1',
  //   jobGroupId: 1,
  // },
  // {
  //   jobId: 20,
  //   jobName: 'Demo Job Group 123',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Boudia, David',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 5000,
  //   excludedErrorDocCount: 5000,
  //   status: 'Complete',
  //   jobGroupName: 'Group 2',
  //   jobGroupId: 2,
  // },
  // {
  //   jobId: 19,
  //   jobName: 'Demo Priv Log Description JKL',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: null,
  //   createdBy: 'Katz, Shane',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: null,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'Draft',
  //   jobGroupName: 'Group 3',
  //   jobGroupId: 3,
  // },
  // {
  //   jobId: 18,
  //   jobName: 'Demo Review Job Group GHI',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Boudia, David',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 5000,
  //   excludedErrorDocCount: 5000,
  //   status: 'Complete',
  //   jobGroupName: null,
  //   jobGroupId: null,
  // },
  // {
  //   jobId: 17,
  //   jobName: 'Demo Job Group 123',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: null,
  //   createdBy: 'Boisclair, Gerard',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 0,
  //   excludedErrorDocCount: 10000,
  //   status: 'Failed',
  //   jobGroupName: 'Group 1',
  //   jobGroupId: 1,
  // },
  // {
  //   jobId: 16,
  //   jobName: 'TestingKara',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Coles, Chad',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'In Progress',
  //   jobGroupName: 'Group 3',
  //   jobGroupId: 3,
  // },
  // {
  //   jobId: 15,
  //   jobName: 'ztest1',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Boisclair, Gerard',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'In Progress',
  //   jobGroupName: 'Group 1',
  //   jobGroupId: 1,
  // },
  // {
  //   jobId: 14,
  //   jobName: 'Demo Job Group 123',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Boudia, David',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 5000,
  //   excludedErrorDocCount: 5000,
  //   status: 'Complete',
  //   jobGroupName: 'Group 2',
  //   jobGroupId: 2,
  // },
  // {
  //   jobId: 13,
  //   jobName: 'Demo Priv Log Description JKL',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: null,
  //   createdBy: 'Katz, Shane',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: null,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'Draft',
  //   jobGroupName: 'Group 3',
  //   jobGroupId: 3,
  // },
  // {
  //   jobId: 12,
  //   jobName: 'Demo Review Job Group GHI',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:42',
  //   createdBy: 'Boudia, David',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 5000,
  //   excludedErrorDocCount: 5000,
  //   status: 'Complete',
  //   jobGroupName: null,
  //   jobGroupId: null,
  // },
  // {
  //   jobId: 11,
  //   jobName: 'Demo Job Group 123',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:39',
  //   executionDate: null,
  //   createdBy: 'Boisclair, Gerard',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 0,
  //   excludedErrorDocCount: 10000,
  //   status: 'Failed',
  //   jobGroupName: 'Group 1',
  //   jobGroupId: 1,
  // },
  // {
  //   jobId: 10,
  //   jobName: 'TestingKara',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:40',
  //   createdBy: 'Coles, Chad',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'In Progress',
  //   jobGroupName: 'Group 3',
  //   jobGroupId: 3,
  // },
  // {
  //   jobId: 9,
  //   jobName: 'ztest1',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:35',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Boisclair, Gerard',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'In Progress',
  //   jobGroupName: 'Group 1',
  //   jobGroupId: 1,
  // },
  // {
  //   jobId: 8,
  //   jobName: 'Demo Job Group 123',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:38',
  //   createdBy: 'Boudia, David',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 5000,
  //   excludedErrorDocCount: 5000,
  //   status: 'Complete',
  //   jobGroupName: 'Group 2',
  //   jobGroupId: 2,
  // },
  // {
  //   jobId: 7,
  //   jobName: 'Demo Priv Log Description JKL',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:38',
  //   executionDate: null,
  //   createdBy: 'Katz, Shane',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: null,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'Draft',
  //   jobGroupName: 'Group 3',
  //   jobGroupId: 3,
  // },
  // {
  //   jobId: 6,
  //   jobName: 'Demo Review Job Group GHI',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Boudia, David',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 5000,
  //   excludedErrorDocCount: 5000,
  //   status: 'Complete',
  //   jobGroupName: null,
  //   jobGroupId: null,
  // },
  // {
  //   jobId: 5,
  //   jobName: 'Demo Job Group 123',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: null,
  //   createdBy: 'Boisclair, Gerard',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 0,
  //   excludedErrorDocCount: 10000,
  //   status: 'Failed',
  //   jobGroupName: 'Group 1',
  //   jobGroupId: 1,
  // },
  // {
  //   jobId: 4,
  //   jobName: 'TestingKara',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Coles, Chad',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'In Progress',
  //   jobGroupName: 'Group 3',
  //   jobGroupId: 3,
  // },
  // {
  //   jobId: 3,
  //   jobName: 'ztest1',
  //   jobType: 'Relevancy',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Boisclair, Gerard',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'In Progress',
  //   jobGroupName: 'Group 1',
  //   jobGroupId: 1,
  // },
  // {
  //   jobId: 2,
  //   jobName: 'Demo Job Group 123',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: '2025/02/06 14:26:36',
  //   createdBy: 'Boudia, David',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: 10000,
  //   completedDocCount: 5000,
  //   excludedErrorDocCount: 5000,
  //   status: 'Complete',
  //   jobGroupName: 'Group 2',
  //   jobGroupId: 2,
  // },
  // {
  //   jobId: 1,
  //   jobName: 'Demo Review Job Group 281',
  //   jobType: 'Issue Coding',
  //   createdDate: '2025/02/06 14:26:36',
  //   executionDate: null,
  //   createdBy: 'Katz, Shane',
  //   source: 'Saved Search: 418349',
  //   totalDocCount: null,
  //   completedDocCount: null,
  //   excludedErrorDocCount: null,
  //   status: 'Queued',
  //   jobGroupName: 'Group 3',
  //   jobGroupId: 3,
  // },
];

export function getMockPageData(
  page: number,
  limit: number,
  order: any,
  filters: any
) {
  const startIndex = (page - 1) * limit;
  const endIndex = page * limit;
  let data = MockJobs.slice(startIndex, endIndex);
  if (filters.length > 0) {
    data = data.filter((item: any) => {
      let isFound = false;
      for (let filter of filters) {
        isFound = item[filter.field]
          ?.toLowerCase()
          .includes(filter.value.toLowerCase());
        if (!isFound) return isFound;
      }
      return isFound;
    });
  }
  data.sort((a: any, b: any) => {
    if (a[order.field] < b[order.field]) return order.sort === 'asc' ? -1 : 1;
    if (a[order.field] > b[order.field]) return order.sort === 'asc' ? 1 : -1;

    return 0;
  });
  return {
    // page,
    // limit,
    totalCount: MockJobs.length,
    // totalPages: Math.ceil(MockJobs.length / limit),
    jobs: data,
  };
}

export const mockActions = [
  {label: 'Action 1', id: 'action1'},
  {label: 'Action 2', id: 'action2'},
];

const ISSUE_CODES = [
  'Trade-Secret',
  'Source-Code',
  'VC-Funding',
  'Data-Exfiltration',
  'Fiduciary-Breach',
  'Forensic-Evidence',
  'Product-Roadmap',
  'Employment-Agreements',
];

export const MockIssueCodeData = Array.from({length: 100}, (_, index) => {
  const id = index + 1;

  return {
    id,
    issue_code: ISSUE_CODES[index % ISSUE_CODES.length],
    question: 'Reference whistleblower complaints or financial audit findings',
    relevant_docs: (15000 - id * 50).toLocaleString(),
    non_relevant_docs: (3000 - id * 10).toLocaleString(),
  };
});

export function getMockIssueCodeData(
  page: number,
  limit: number,
  order: any,
  filters: any
) {
  const safeOrder =
    order && typeof order === 'object' && order.field && order.sort
      ? order
      : {field: 'relevant_docs', sort: 'asc'};

  const startIndex = (page - 1) * limit;
  const endIndex = page * limit;

  let data = MockIssueCodeData.slice(startIndex, endIndex);

  if (filters?.length > 0) {
    data = data.filter((item: any) =>
      filters.every((filter: any) =>
        String(item[filter.field] ?? '')
          .toLowerCase()
          .includes(String(filter.value ?? '').toLowerCase())
      )
    );
  }

  data.sort((a: any, b: any) => {
    const aVal = a[safeOrder.field];
    const bVal = b[safeOrder.field];

    if (aVal < bVal) return safeOrder.sort === 'asc' ? -1 : 1;
    if (aVal > bVal) return safeOrder.sort === 'asc' ? 1 : -1;
    return 0;
  });

  return {
    page,
    limit,
    totalItems: MockIssueCodeData.length,
    totalPages: Math.ceil(MockIssueCodeData.length / limit),
    data,
  };
}

export const MockRelevancyData = Array.from({length: 100}, (_, index) => {
  const id = index + 1;
  const isRelevant = id % 4 !== 0;

  return {
    documentId: `ID${String(id).padStart(7, '0')}`,
    relevancy: isRelevant ? 'RELEVANT' : 'NOT_RELEVANT',
    groundTruthIndicator: isRelevant,
    groundTruthRelevancy: isRelevant ? 'RELEVANT' : 'NOT_RELEVANT',
    confidenceScore: Number((generateRandomNumber() * 0.3 + 0.7).toFixed(2)),
    reason: isRelevant
      ? 'Document contains multiple references to pricing negotiations and contract terms that match relevance criteria'
      : 'Document does not contain sufficient indicators related to pricing or contractual discussions',
    excerpt:
      '...we need to finalize the pricing terms by end of Q3. The proposed discount structure outlined in the ABC Corp agreement...',
    fileName: `email_2023_09_${String(id).padStart(2, '0')}_pricing_discussion.eml`,
    dateProcessed: new Date(
      Date.now() - id * 24 * 60 * 60 * 1000
    ).toISOString(),
  };
});
export function getMockRelevancyData(
  jobId: string,
  page: number,
  limit: number,
  order: any,
  filters: any
) {
  const safeOrder = order?.field ? order : {field: 'documentId', sort: 'asc'};

  let data = [...MockRelevancyData];

  if (filters?.length) {
    data = data.filter((row) =>
      filters.every((filter: any) =>
        String(row[filter.field] ?? '')
          .toLowerCase()
          .includes(String(filter.value ?? '').toLowerCase())
      )
    );
  }

  data.sort((a: any, b: any) => {
    const aVal = a[safeOrder.field];
    const bVal = b[safeOrder.field];

    if (aVal < bVal) return safeOrder.sort === 'asc' ? -1 : 1;
    if (aVal > bVal) return safeOrder.sort === 'asc' ? 1 : -1;
    return 0;
  });

  const start = (page - 1) * limit;
  const end = page * limit;

  return {
    jobId,
    documents: data.slice(start, end),
    totalCount: data.length,
  };
}
